import logo from "./images/logo.png";
export const PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.quantingo.resus";
export function Brand() {
  return (
    <a className="brand" href="#about" aria-label="Resus">
      <img src={logo} alt="" width="40" height="40" />
      <span>Resus</span>
    </a>
  );
}
export function StoreLink({ label, compact = false }) {
  return (
    <a
      className={`button ${compact ? "button-compact" : ""}`}
      href={PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      {!compact && (
        <svg
          width="20"
          height="22"
          viewBox="0 0 20 22"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M2 2L18 11L2 20V2Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M2 2L12 14.5M2 20L12 7.5"
            stroke="currentColor"
            strokeWidth="1.2"
          />
        </svg>
      )}
      {label}
      <span aria-hidden="true">↗</span>
    </a>
  );
}
